import { render, staticRenderFns } from "./ReceiveOrder.vue?vue&type=template&id=484d673d&scoped=true&"
import script from "./ReceiveOrder.vue?vue&type=script&lang=js&"
export * from "./ReceiveOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d673d",
  null
  
)

export default component.exports